goog.provide("shadow.js.shim.module$react_use$lib$useMeasure$default");
shadow.js.shim.module$react_use$lib$useMeasure$default = shadow.js.shim.module$react_use$lib$useMeasure.default;
